// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__NpWHZ","icon":"SortAdornment_icon__qi7cs","up":"SortAdornment_up__1nC1f","down":"SortAdornment_down__38DE1","active":"SortAdornment_active__1xH7t"};